var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateNewAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Create_New_Assessment"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create_New_Assessment",
    "data-name": "Create New Assessment",
    clipPath: "url(#clip-Create_New_Assessment)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_623",
    "data-name": "Ellipse 623",
    transform: "translate(1 1)",
    fill: "#0069bf",
    stroke: "#0081ea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Q_A",
    "data-name": "Q/A",
    transform: "translate(5 14.5)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q/A")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewAssessment);
export default __webpack_public_path__ + "static/media/Create New Assessment.5baea05e80030da1b94ef67385c0d961.svg";
export { ForwardRef as ReactComponent };